// extracted by mini-css-extract-plugin
module.exports = {"footerOpen":"YourCart_footerOpen__STSSn","move-up":"YourCart_move-up__UK0Yl","footerClose":"YourCart_footerClose__fjo9Z","move-down":"YourCart_move-down__8HFkg"};